import React, { useState } from "react";
import "./Education.css";
import AccordionItem from "./../../components/AccordionItem";

const Education = () => {
  const [activeSection, setActiveSection] = useState("What is Diamond?");

  const toggleSection = (title) => {
    setActiveSection((prev) => (prev === title ? null : title));
  };

  return (
    <div className="education1-container1">
      <h1 className="education1-title">Education</h1>
      <div className="education1-content">
        {educationData.map((section) => (
          <AccordionItem
            key={section.title}
            title={section.title}
            content={section.content}
            isActive={activeSection === section.title}
            onToggle={() => toggleSection(section.title)}
          />
        ))}
      </div>
    </div>
  );
};

export default Education;

const educationData = [
  {
    title: "What is Diamond?",
    content: (
      <div className="paragraph">
        <p>
          Diamonds were formed billions of years ago under intense heat and
          pressure when diamond-bearing ore was brought to the surface through
          volcanic eruption. After the magma cooled, it solidified into blue
          ground, or kimberlite, where precious rough diamonds are still found
          today.
        </p>
        <p>
          Diamond is an allotrope of carbon where the carbon atoms are arranged
          in a variation of the face-centered cubic crystal structure called a
          diamond lattice. Diamond is renowned as a material with superlative
          physical qualities, most of which originate from the strong covalent
          bonding between its atoms. In particular, diamond has the highest
          hardness and thermal conductivity of any bulk material.
        </p>
        <p>
          The formation of natural diamond requires very specific
          conditions—exposure of carbon-bearing materials to high pressure,
          ranging approximately between 45 and 60 kilo bars (4.5 and 6 GPa), but
          at a comparatively low temperature range between approximately
          900–1300 °C (1652–2372 °F). These conditions are met in two places on
          Earth: in the lithospheric mantle below relatively stable continental
          plates, and at the site of a meteorite strike. Most natural diamonds
          are formed at high temperature and pressure at depths of 140 to 190
          kilometers (87 to 120 miles) in the Earth's mantle. Carbon-containing
          minerals provide the carbon source, and the growth occurs over periods
          from 1 billion to 3.3 billion years.
        </p>
      </div>
    ),
  },
  {
    title: "Shapes",
    content: (
      <div >
        <div className="containerxyz">
          <div className="text-contentxyz">
            <p className="headingxyz">Shapes</p>
            <p className="paragraphxyz">
              The classic diamond is, to most people, a round gem of sparkling
              white brilliance with a kaleidoscope of dazzling facets to entice
              the eye. Yes and no. Diamonds are natural crystals of varying size
              and shape formed in the earth over millions of years. The
              traditional round brilliant diamond, though the most popular
              diamond shape of all, is hardly the whole story. By the diamond
              cutter's art these crystals are carved into gems of spectacular
              and whimsical beauty. A cutter's skill will produce a diamond of
              the greatest size with the fewest flaws and the most brilliance.
            </p>
            <p className="headingxyz">Round Brilliant Diamonds</p>
            <p className="paragraphxyz">
              This shape has set the standard for all other diamond shapes, and
              accounts for more than 75% of diamonds sold today. Its 58-facet
              cut, divided among its crown (top), girdle (widest part) and
              pavilion (base), is calibrated through a precise formula to
              achieve the maximum in fire and brilliance. Developed ca. 1900,
              the round brilliant is the most popular cut given to diamond. It
              is usually the best choice in terms of saleability, insurability
              (due to its relatively "safe" shape), and desired optics.
            </p>
          </div>
          <div className="shape-imgsxyz">
            <img
              src={require("../../assets/education/shape_images.jpg")}
              alt="Diamond proportions diagram"
            />
          </div>
        </div>

        <div className="containerxyz">
          <div className="text-contentxyz">
            <p className="headingxyz">Oval Diamonds</p>
            <p className="paragraphxyz">
              An even, perfectly symmetrical design popular among women with
              small hands or short fingers. Its elongated shape gives a
              flattering illusion of length to the hand. The Oval Diamond has
              beautiful brilliance that's similar to a round diamond. Oval
              diamonds are also very popular as their length can accentuate
              long, slender fingers. The history of the brilliant-cut oval
              diamond is relatively easy to track because it is a relatively
              young shape. Created by Lazare Kaplan in the late 1950s - early
              1960s, the oval brilliant cut is an elipitical variation of the
              more common round brilliant. The modern oval cut is a fiery
              diamond that reflects light brilliantly. It's a wonderful
              selection for someone who loves the sparkle of the round
              brilliant, but desires a less common shape.
            </p>
          </div>
          <div className="shape-imgsxyz">
            <img
              src={require("../../assets/education/Oval_Diamonds.jpg")}
              alt="Oval Diamond"
            />
          </div>
        </div>

        <div className="containerxyz">
          <div className="text-contentxyz">
            <p className="headingxyz">Marquise Diamonds</p>
            <p className="paragraphxyz">
              An elongated shape with pointed ends inspired by the fetching
              smile of the Marquise de Pompadour and commissioned by the Sun
              King, France's Louis XIV, who wanted a diamond to match it. It is
              gorgeous when used as a solitaire or when enhanced by smaller
              diamonds.
            </p>
          </div>
          <div className="shape-imgsxyz">
            <img
              src={require("../../assets/education/Marquise_Diamonds.jpg")}
              alt="Marquise Diamond"
            />
          </div>
        </div>

        <div className="containerxyz">
          <div className="text-contentxyz">
            <p className="headingxyz">Pear Shaped Diamonds</p>
            <p className="paragraphxyz">
              A hybrid cut, combining the best of the oval and the marquise, it
              is shaped most like a sparkling teardrop. It also belongs to that
              category of diamond whose design most complements a hand with
              small or average-length fingers. It is particularly beautiful for
              pendants or earrings. The pear shaped diamond is also called the
              "teardrop diamond" because of its shape. The pear shaped diamond
              is a combination cut of the round-brilliant and the marquise. The
              Pear Shaped Diamond is a fiery cut with lots of wonderful sparkle
              and flash. The elegant lines lend a sophisticated air to both the
              simplest and most elaborate ring settings.
            </p>
          </div>
          <div className="shape-imgsxyz">
            <img
              src={require("../../assets/education/PearShaped_Diamonds.jpg")}
              alt="Pear Diamond"
            />
          </div>
        </div>

        <div className="containerxyz">
          <div className="text-contentxyz">
            <p className="headingxyz">Heart Shaped Diamonds</p>
            <p className="paragraphxyz">
              This ultimate symbol of romance is essentially a pear-shaped
              diamond with a cleft at the top. The skill of the cutter
              determines the beauty of the cut. Look for a stone with an even
              shape and a well-defined outline. Though a technical description
              of the heart-shaped diamond is anything but sentimental, it is
              considered by some to be the most romantic of all diamond cuts.
              The heart shaped diamond can be quite fiery with excellent
              sparkle.
            </p>
          </div>
          <div className="shape-imgsxyz">
            <img
              src={require("../../assets/education/HeatShape_Diamonds.jpg")}
              alt="Heart Diamond"
            />
          </div>
        </div>

        <div className="containerxyz">
          <div className="text-contentxyz">
            <p className="headingxyz">Emerald Cut Diamond</p>
            <p className="paragraphxyz">
              This is a rectangular shape with cut corners. It is known as a
              step cut because its concentric broad, flat planes resemble stair
              steps. Since inclusions and inferior color are more pronounced in
              this particular cut, take pains to select a stone of superior
              clarity and color. The stepped, normally rectangular cut with
              cropped corners was originally developed for cutting emeralds. It
              was soon discovered the cut was also suitable for other stones,
              including diamonds. The emerald cut diamond can be absolutely
              stunning with long lines and broader, more dramatic flashes of
              light. It lends an elegant, sophisticated air to both simple and
              elaborate settings.
            </p>
          </div>
          <div className="shape-imgsxyz">
            <img
              src={require("../../assets/education/emrald_Diamond.jpg")}
              alt="Emrald Diamond"
            />
          </div>
        </div>

        <div className="containerxyz">
          <div className="text-contentxyz">
            <p className="headingxyz">Princess Cut Diamond</p>
            <p className="paragraphxyz">
              This is a square or rectangular cut with numerous sparkling
              facets. A relatively new cut, often used in solitaire engagement
              rings. It flatters a hand with long fingers and is often enhanced
              with triangular stones at its sides. Because of its design, this
              cut requires more weight to be directed toward the diamond's depth
              in order to maximize brilliance. Depth percentages of 70% to 78%
              are not uncommon. The Princess Cut was designed to get maximum
              brilliance from a square cut. Always ensure the setting protects
              the four pointed corners — these are the points most likely to
              chip.
            </p>
          </div>
          <div className="shape-imgsxyz">
            <img
              src={require("../../assets/education/princessCut_Diamond.jpg")}
              alt="Princess Diamond"
            />
          </div>
        </div>

        <div className="containerxyz">
          <div className="text-contentxyz">
            <p className="headingxyz">Radiant Cut Diamonds</p>
            <p className="paragraphxyz">
              This square or rectangular cut combines the elegance of the
              emerald shape with the brilliance of the round, and its 70 facets
              maximize color refraction. Like the emerald cut, the radiant cut
              is often a rectangle (sometimes square) with cropped corners.
              However, the radiant cut is faceted for fire and offers maximum
              brilliance. A great option for those who love the sparkle of a
              Round Brilliant but the shape of an Emerald or Asscher cut.
            </p>
          </div>
          <div className="shape-imgsxyz">
            <img
              src={require("../../assets/education/Radiant_diamonds.jpg")}
              alt="Radiant Diamond"
            />
          </div>
        </div>

        <div className="containerxyz">
          <div className="text-contentxyz">
            <p className="headingxyz">Trilliant Diamonds</p>
            <p className="paragraphxyz">
              This is a spectacular wedge of brittle fire. First developed in
              Amsterdam, it may be a traditional triangle with pointed corners
              or a rounded triangular shape with 25 facets on the crown and 19
              on the pavilion. It is definitely for the adventurous.
            </p>
          </div>
        </div>

        <div className="containerxyz">
          <div className="text-contentxyz">
            <p className="headingxyz">Cushion Cut Diamond</p>
            <p className="paragraphxyz">
              An antique style of cut that looks like a cross between an Old
              Mine Cut and a modern oval cut. Once only found in estate sales,
              cushion cuts are enjoying renewed popularity. Sometimes called
              pillow-cut or candlelight diamonds, this cut isn't as fiery as
              newer cuts but has a romantic and classic look that stands out.
              The shape of things to come includes fanciful and innovative
              styles such as the flower, cloverleaf, triangle, and kite.
              Individuality and taste determine the fashion, and the gem
              cutter’s art makes each stone unique.
            </p>
          </div>
        </div>
      </div>
    ),
  },
  {
    title: "Carat",
    content: (
      <div >
        <div className="containerxyz">
          <div className="text-contentxyz">
            <p className="headingxyz">Carat</p>
            <p className="paragraphxyz">
              Carat is the unit of measurement used to describe the weight of
              diamonds. One carat is equal to 0.2 grams, or 0.007 ounces
              (avoirdupois). Five carats equals 1 gram, and 141.7 carats equals
              1 ounce.
              <br />
              <br />
              Carat weight is commonly expressed in points or fractions. There
              are 100 points in 1 carat. For instance, 0.33 carats is generally
              expressed as 33 points, or 1/3 of a carat.
              <br />
              <br />
              <strong>Why is carat weight important?</strong>
              <br />
              The carat weight of a diamond is a major factor in its price, but
              the cut, color, and clarity will also affect the price greatly. A
              0.50-carat diamond with high color and clarity ratings may cost
              more than a 0.75-carat diamond with lower color and clarity
              ratings.
              <br />
              <br />
              Within a specific price range, you will find a number of
              combinations of diamond carat weight and quality. If you value
              size over quality, you might choose a 1.00-carat diamond with an I
              or J color and SI2 clarity with a Good cut to get maximum size.
              For the same price, if you value quality over size, you might
              choose a 0.75-carat diamond with an E or F color and VS2 clarity
              with an Ideal cut.
              <br />
              <br />
              Because large diamonds are much rarer in nature than small ones,
              diamond value increases exponentially for certain thresholds of
              diamond carat weights. A 1.00-carat diamond will cost more than
              twice as much as a 0.50-carat diamond of comparable quality.
              <br />
              <br />
              <strong>Does carat weight affect diamond size?</strong>
              <br />
              As diamond carat size increases, both the diameter and the depth
              of the diamond increase. This is why a 1.00-carat diamond
              (approximate 6.5mm diameter) does not look twice as wide as a
              0.50-carat diamond (approximate 5mm diameter).
              <br />
              <br />
              When choosing a diamond size, keep the size of the wearer in mind.
              A 1.00-carat solitaire will appear much larger on a size 4 finger
              than on a size 8.
              <br />
              <br />
              <strong>Minimum Individual Carat Weight</strong>
              <br />
              Minimum individual carat weight is the minimum carat weight of one
              diamond in a piece of jewelry. If a pair of diamond stud earrings
              has a total diamond weight of 1/2 carat, the individual carat
              weight of each diamond would be 1/4 carat. The actual diamonds you
              purchase may weigh slightly more or less than the fractional
              weight specified. The Federal Trade Commission has strict
              guidelines about the disclosure of the range of carat weight that
              a fraction can represent.
              <br />
              <br />
              <strong>Approximate Ranges for Carat Weights:</strong>
              <br />
              1/4 carat total weight: 0.21 to 0.29 carats
              <br />
              1/3 carat total weight: 0.30 to 0.36 carats
              <br />
              1/2 carat total weight: 0.45 to 0.59 carats
              <br />
              3/4 carat total weight: 0.70 to 0.84 carats
              <br />
              1 carat total weight: 0.95 to 1.10 carats
              <br />
              1 1/4 carats total weight: 1.20 to 1.29 carats
              <br />
              1 1/2 carats total weight: 1.45 to 1.55 carats
              <br />2 carats total weight: 1.95 to 2.05 carats
            </p>
          </div>
          <div className="shape-imgsxyz">
            <img
              src={require("../../assets/education/carat_Diamonds.jpg")}
              alt="Carat weight illustration"
            />
          </div>
        </div>
      </div>
    ),
  },
  {
    title: "Color",
    content: (
      <div >
        <div className="containerxyz">
          <div className="text-contentxyz">
            <p className="headingxyz">Color</p>
            <p className="paragraphxyz">
              Diamonds are found in almost every color of the rainbow, but
              "white" (colorless) diamonds remain the most popular.
              <br />
              <br />
              The finest and most expensive diamonds are totally without color,
              like a drop of distilled water. The rainbow hues a diamond flashes
              derive from the light it separates into the colors of a spectrum.
              Diamonds of lesser quality often show a yellowish or brownish
              cast.
              <br />
              <br />
              When describing the color of a diamond, the reference is to the
              degree of body color present. The less color a diamond displays,
              the higher its color grade. Diamonds displaying very little color
              allow more light to pass through, creating a prism effect with
              flashes of color and brilliance—known as "fire."
              <br />
              <br />
              The Gemological Institute of America (GIA) grades white diamonds
              on a scale from D (completely colorless) to Z (noticeable yellow
              or brown tint). Beyond the Z grade lies a range of "fancy color"
              diamonds, which exhibit vivid hues like pink, blue, or yellow.
              <br />
              <br />
              To grade color accurately, diamonds are compared against "master
              stones" under controlled lighting—either artificial light that
              mimics daylight or actual northern daylight. While machines like
              the Colorimeter can assist in this process, there is no substitute
              for a trained human eye in assessing diamond color accurately.
            </p>
          </div>
        </div>
          <div className="shape-imgs-center">
            <img
              src={require("../../assets/education/color_Diamonds.jpg")}
              alt="Diamond color grading chart"
            />
          </div>
      </div>
    ),
  },
  {
    title: "Clarity",
    content: (
      <div >
        <div className="containerxyz">
          <div className="text-contentxyz">
            <p className="headingxyz">Clarity</p>
            <p className="paragraphxyz">
              Every diamond is unique. Nature ensures that each diamond is as
              individual as the person who wears it. Diamond clarity refers to
              the presence or absence of internal features known as inclusions
              and external features known as blemishes.
              <br />
              <br />
              Inclusions may be tiny crystals of foreign material or even
              another diamond, or structural imperfections such as microscopic
              cracks, which can appear whitish or cloudy. Blemishes occur on the
              surface and may include scratches or nicks.
              <br />
              <br />
              The number, size, position, and visibility of these
              characteristics under 10x magnification determine a diamond’s
              clarity grade. A higher clarity grade generally means greater
              rarity and value, with the top-tier “Flawless” diamonds commanding
              the highest prices.
              <br />
              <br />
              Interestingly, small inclusions can also act as identifying
              marks—like fingerprints—that help authenticate a diamond and
              distinguish it from others.
              <br />
              <br />
              The Gemological Institute of America (GIA) clarity grading scale
              is divided into six categories and eleven grades:
            </p>
            <ul
              className="paragraphxyz"
              style={{ marginTop: "1rem", paddingLeft: "1.5rem" }}
            >
              <li>
                <strong>FL (Flawless):</strong> No inclusions or blemishes
                visible under 10x magnification
              </li>
              <li>
                <strong>IF (Internally Flawless):</strong> No inclusions, only
                blemishes visible under 10x magnification
              </li>
              <li>
                <strong>VVS1 and VVS2 (Very, Very Slightly Included):</strong>{" "}
                Inclusions are extremely difficult to see under 10x
                magnification
              </li>
              <li>
                <strong>VS1 and VS2 (Very Slightly Included):</strong> Minor
                inclusions that are difficult to moderately easy to see under
                10x magnification
              </li>
              <li>
                <strong>SI1 and SI2 (Slightly Included):</strong> Inclusions are
                noticeable under 10x magnification
              </li>
              <li>
                <strong>I1, I2, and I3 (Included):</strong> Inclusions are
                obvious under 10x magnification and may affect transparency and
                brilliance
              </li>
            </ul>
          </div>
        </div>
          <div className="shape-imgs-center">
            <img
              src={require("../../assets/education/Clarity_Diamonds.jpg")}
              alt="Diamond clarity grading chart"
            />
          </div>
      </div>
    ),
  },
  {
    title: "Cut",
    content: (
      <div >
        <div className="containerxyz">
          <div className="text-contentxyz">
            <p className="headingxyz">Cut</p>
            <p className="paragraphxyz">
              Nature determines so much about a diamond, but it takes a master
              cutter to reveal the stone's true brilliance, fire, and ultimate
              beauty.
              <br />
              <br />
              Based on scientific formulas, a well-cut diamond will internally
              reflect light from one mirror-like facet to another and then
              disperse and reflect it through the top of the stone. This creates
              the sparkle, brilliance, and fire we associate with exceptional
              diamonds. If a diamond is cut too deep or too shallow, it leaks
              light through the sides or bottom, reducing its brilliance and
              value.
              <br />
              <br />
              Of all the 4Cs, cut is the only one directly shaped by human
              hands. The others—carat, color, and clarity—are determined by
              nature.
            </p>
            <ul
              className="paragraphxyz"
              style={{ marginTop: "1rem", paddingLeft: "1.5rem" }}
            >
              <li>
                <strong>Super Ideal Cut:</strong> Represents the top 1% of
                diamond cut quality. Exceptional polish and symmetry allow it to
                reflect maximum light and brilliance.
              </li>
              <li>
                <strong>Ideal/Excellent Cut:</strong> Top 3% of diamond quality
                based on cut. Reflects nearly all light that enters. Exquisite
                and rare.
              </li>
              <li>
                <strong>Very Good Cut:</strong> Top 15% of diamond quality.
                Reflects almost as much light as an ideal cut, but at a lower
                price point.
              </li>
              <li>
                <strong>Good Cut:</strong> Top 25% of diamond quality. Reflects
                most incoming light. Offers value for budget-conscious buyers.
              </li>
              <li>
                <strong>Fair Cut:</strong> Top 35% of diamond quality. Still a
                quality diamond, though less brilliant than higher cuts.
              </li>
              <li>
                <strong>Poor Cut:</strong> Often too deep or shallow. Loses
                significant light from the sides and bottom, resulting in less
                sparkle and diminished beauty.
              </li>
            </ul>
            <p className="paragraphxyz" style={{ marginTop: "1rem" }}>
              <strong>Diamond Cut Proportions:</strong>
              <br />
              Cut proportions refer to the relationship between a diamond's
              size, shape, and the angles of its facets. These proportions
              determine how light behaves inside the diamond.
              <br />
              <br />
              About 20% of light reflects off the surface immediately (glare),
              while the remaining 80% enters the stone. A well-cut diamond
              ensures that most of this light reflects back through the crown to
              the observer’s eye—producing brilliance, scintillation, and fire.
              <br />
              <br />
              Poorly cut diamonds allow light to escape from the bottom or
              sides. That’s why cut is so crucial: it maximizes a diamond's
              visual impact.
            </p>
          </div>
        </div>
          <div className="shape-imgs-center">
            <img
              src={require("../../assets/education/Cut_Diamonds.jpg")}
              alt="Diamond cut light reflection diagram"
            />
          </div>
      </div>
    ),
  },
  {
    title: "Polish",
    content: (
      <div >
        <div className="containerxyz">
          <div className="text-contentxyz">
            <p className="headingxyz">Polish</p>
            <p className="paragraphxyz">
              When diamond graders consider the Polish grade, they evaluate the
              presence and visibility of any "polish imperfections" on the
              diamond's surface. These imperfections can include pits,
              scratches, chips, polish lines, or burn marks.
              <br />
              <br />
              There are five GIA Polish categories:
            </p>
            <ul
              className="paragraphxyz"
              style={{ marginTop: "1rem", paddingLeft: "1.5rem" }}
            >
              <li>
                <strong>Excellent:</strong> No polish features are visible to
                the naked eye. The diamond has a pristine, flawless surface.
              </li>
              <li>
                <strong>Very Good:</strong> No polish features can be seen
                without magnification. The diamond surface remains highly
                reflective.
              </li>
              <li>
                <strong>Good:</strong> Polish features are present but not
                visible to the naked eye. The diamond retains much of its
                luster, but the features may affect its brilliance slightly.
              </li>
              <li>
                <strong>Fair:</strong> Surface marks are noticeable with the
                naked eye. These imperfections begin to impact the diamond's
                overall luster.
              </li>
              <li>
                <strong>Poor:</strong> Polish features are clearly visible to
                the naked eye. The luster and shine of the diamond are
                significantly diminished due to these imperfections.
              </li>
            </ul>
            <p className="paragraphxyz" style={{ marginTop: "1rem" }}>
              A diamond with an Excellent or Very Good Polish grade will have a
              surface free from visible marks, offering the best overall
              appearance. As the Polish grade drops, the diamond's surface
              becomes more visibly affected, impacting its overall beauty and
              sparkle.
            </p>
          </div>
        </div>
      </div>
    ),
  },
  {
    title: "Symmetry",
    content: (
      <div >
        <div className="containerxyz">
          <div className="text-contentxyz">
            <p className="headingxyz">Symmetry</p>
            <p className="paragraphxyz">
              Diamond Symmetry refers to how well the various facets of a
              diamond are aligned, proportional, and symmetrical to each other.
              Graders evaluate the overall alignment and symmetry of the facets,
              which can impact the diamond's brilliance and visual appeal. Even
              small discrepancies in symmetry can affect how light enters and
              exits the stone, influencing its sparkle.
              <br />
              <br />
              The GIA grades Diamond Symmetry in five categories:
            </p>
            <ul
              className="paragraphxyz"
              style={{ marginTop: "1rem", paddingLeft: "1.5rem" }}
            >
              <li>
                <strong>Excellent:</strong> The diamond exhibits perfect
                symmetry with no noticeable imperfections even under 10x
                magnification. It will have ideal visual appeal.
              </li>
              <li>
                <strong>Very Good:</strong> Symmetry is almost perfect, with
                only minor deviations that are difficult to see under 10x
                magnification. The diamond retains excellent brilliance.
              </li>
              <li>
                <strong>Good:</strong> Symmetry is visibly noticeable under 10x
                magnification but does not significantly affect the diamond's
                overall appearance or sparkle.
              </li>
              <li>
                <strong>Fair:</strong> The diamond shows significant symmetry
                issues that are visible under magnification. These flaws may
                slightly diminish the sparkle of the diamond.
              </li>
              <li>
                <strong>Poor:</strong> Symmetry is clearly flawed, and these
                issues are easily noticeable even without magnification. The
                diamond may lack brilliance and sparkle due to poor facet
                alignment.
              </li>
            </ul>
            <p className="paragraphxyz" style={{ marginTop: "1rem" }}>
              Diamonds with Excellent or Very Good symmetry are the most
              visually appealing, maintaining their brilliance. Good symmetry
              may still offer acceptable aesthetics, but diamonds with Fair or
              Poor symmetry will likely show noticeable flaws, resulting in less
              sparkle and a diminished visual effect.
            </p>
          </div>
        </div>
      </div>
    ),
  },
  {
    title: "Hearts And Arrows",
    content: (
      <div >
        <div className="containerxyz">
          <div className="text-contentxyz">
            <p className="headingxyz">Hearts And Arrows</p>
            <p className="paragraphxyz">
              A "Hearts & Arrows" cut diamond is the finest cut diamond,
              celebrated for its exceptional symmetry and precision. Extremely
              rare, these diamonds are known for their unique sentimental charm
              and mystery. The term "Hearts and Arrows" refers to the distinct
              visual effect created by a round brilliant cut diamond that has
              been crafted with perfect symmetry and specific angles.
              <br />
              <br />
              When viewed under a special magnifying viewer, the diamond
              displays a crisp and complete pattern of 8 hearts when viewed from
              the pavilion (bottom) side. Similarly, when the diamond is viewed
              from the table (top) side, the viewer will see a pattern of 8
              arrows. These patterns are a direct result of the meticulous
              precision and perfect alignment of the facets, ensuring that light
              is reflected in the most spectacular way possible.
            </p>
          </div>
        </div>
          <div className="shape-imgs-center">
            <img
              src={require("../../assets/education/heart-arrow_Diamonds.jpg")}
              alt="Hearts and Arrows diamond pattern"
            />
          </div>
      </div>
    ),
  },
  // {
  //   title: "Fancy Color Diamond",
  //   content: (
  //     <p className="paragraph">
  //       Fancy color diamonds are natural diamonds that exhibit intense colors
  //       such as yellow, pink, blue, and green. They are very rare and valuable.
  //     </p>
  //   ),
  // },
  {
    title: "How Are Fancy Colors Graded?",
    content: (
      <div >
        <div className="containerxyz">
          <div className="text-contentxyz">
            <p className="paragraphxyz">
              Fancy Color begins beyond the grade Z in the color grading scale.
              (shown above) While colorless, near colorless, faint and light
              diamond colors are graded from the face-down position. Laboratory
              graders assess fancy color diamonds from the face-up or top view
              of the diamond.
              <br />
              <br />
              Graders evaluate the hue, tone, and saturation of each diamond.
              <br />
              <br />
              <b>Hue</b> - A diamond's overall body color
              <br />
              <b>Tone</b> - A diamond's lightness or darkness in relation to
              body color
              <br />
              <b>Saturation</b> - The intensity or degree of color
              <br />
              <br />
              Secondary or modifying colors are also assessed, as they impact
              the overall hue of the fancy color. For example, a yellow diamond
              may have a green secondary, and will subsequently be graded as
              "Fancy Greenish Yellow." A blue diamond may have a grey secondary
              color, and will be graded as "Fancy Greyish Blue" and so on.
              <br />
              <br />
              Fancy diamond colours are also described by color “overtone”
              (modifying colour). Modifying color is always listed before the
              main color.
              <br />
              <br />
              <b>Intensity</b>
              <br />
              The color in Fancy color diamonds is built from three parameters:
              <ul>
                <li>The main color of the diamond</li>
                <li>The secondary color of the diamond (AKA overtone)</li>
                <li>The intensity of the color</li>
              </ul>
              The main color, and if there is a secondary color, together define
              the color tone, however, the strength of color is defined by the
              intensity level. The intensity level can be anywhere from a very
              soft shade to a very strong shade, and the stronger the shade the
              more valuable the diamond is. GIA developed an intensity grading
              scale in order to categorize the intensity levels in the diamond.
              The nine grades in the scale are:
              <ul>
                <li>Faint</li>
                <li>Very Light</li>
                <li>Light</li>
                <li>Fancy Light</li>
                <li>Fancy</li>
                <li>Fancy Intense</li>
                <li>Fancy Vivid, Fancy Deep, Fancy Dark</li>
              </ul>
              Fancy Intense – Fancy intense color diamonds exhibit a moderate
              tone, with a stronger saturation.
              <br />
              Fancy Vivid – Fancy vivid color diamonds are graded as having a
              moderate tone, with a strong saturation. These diamonds exhibit an
              intense, vibrant hue and are considered especially rare and
              valuable.
              <br />
              <br />
              For example, the following image depicts the full scale of color
              intensity in Pink, Blue, and Green color Diamonds. It is clearly
              shown that the intensity scale begins with very soft colors and
              progressively displays a richer color stone.
            </p>
          </div>
          <div className="shape-imgsxyz">
            <img
              src={require("../../assets/education/fancy_grade_Diamonds.jpg")}
              alt="Full scale of color intensity in Pink, Blue, and Green color Diamonds"
            />
          </div>
        </div>
        <div className="containerxyz">
          <div className="text-contentxyz">
            <p className="paragraphxyz">
              However, it is important to understand that not every diamond
              color appears in all intensity levels. For example, Orange
              diamonds cannot be found in Faint, Very Light, or Light
              intensities. Only Fancy Light, Fancy, Fancy Intense, Fancy Vivid,
              and Fancy Deep.
              <br />
              <br />
              The GIA also defines how well the color and intensity is
              distributed throughout the stone. A diamond certificate will
              specify 'even' or 'uneven' according to the percentage of the
              color distribution.
              <br />
              <br />
              The intensity of the color has a direct effect on the value of the
              stone. For example, a Blue diamond or a Pink diamond, which are of
              the rarest in the fancy colored diamond family, are quite costly
              and difficult to find. However, there is a significant difference
              between a Fancy Light Blue and a Fancy Vivid Blue or a Fancy Light
              Pink and a Fancy Intense Pink.
              <br />
              <br />
              Since there is such a wide range of colored diamonds, even stones
              of the same intensity can look quite different from one another.
              At Leibish & Co., the intensity of each diamond is graded on a
              scale of 1-10. The 1-10 scale breaks down different stones of the
              same intensity grade between a weaker or stronger color.
            </p>
          </div>
          <div className="shape-imgsxyz">
            <img
              src={require("../../assets/education/Gia_certi.jpg")}
              alt="Color intensity scale"
            />
          </div>
        </div>
        <div className="containerxyz">
          <div className="text-contentxyz">
            <p className="paragraphxyz">
              The following image saw the Fluorescence effect on Fancy Color
              diamond.
              <br />
              <br />
              A ‘Fancy Intense Pink' diamond with a 1-3 grade is a very weak
              ‘Fancy Intense Pink’ and actually borders a ‘Fancy Pink.’ A ‘Fancy
              Intense Pink’ diamond with a 8-10 has a very strong color and
              actually borders a ‘Fancy Vivid Pink’ diamond. Therefore, it is
              actually quite common to see two diamonds of the same intensity
              grade where one looks as if the color is more intense than in the
              other.
              <br />
              <br />
              The image about depicts four diamonds all graded by GIA as ‘Fancy
              Intense Pink’ with different strengths of the same intensity grade
              (and color tone) between the stones.
              <br />
              <br />
              Exactly what color intensity a diamond will have will not be able
              to be determined from the rough stone. However, the greater the
              color intensity of the rough, the greater the intensity of the
              polished diamond will be. How intense the color will be is also
              greatly affected by the diamond cut and shape of the stone. Also,
              the way colorless stones are being cut (Brilliant cut) is
              different from how Fancy Color Diamonds are cut (Modified).
              <br />
              <br />
              The origin of the diamond is also another factor that affects the
              color intensity. Different diamond mines produce different shades
              or tones of colors. For example, a Pink diamond found in India or
              South Africa can’t compare to a Pink diamond found from the Argyle
              diamond mine in Australia.
            </p>
          </div>
        </div>
          <div className="shape-imgs-center">
            <img
              src={require("../../assets/education/fancy_pink.jpg")}
              alt="Fluorescence effect on Fancy Color diamond"
            />
          </div>
      </div>
    ),
  },
  {
    title: "Fluorescence",
    content: (
      <div >
        <div className="containerxyz">
          <div className="text-contentxyz">
            <p className="headingxyz">Fluorescence</p>
            <p className="paragraphxyz">
              Fluorescence is a characteristic that makes some diamonds appear
              to change color when they are exposed to the ultraviolet light
              that surrounds us every day in sunlight and in the light produced
              by fluorescent light bulbs.
              <br />
              <br />
              <b>Do All Diamonds Fluoresce?</b>
              <br />
              Diamond grading reports reveal whether or not a diamond
              fluoresces, and if it does, how much -- faintly, weakly,
              moderately, strongly or very strongly.
              <br />
              <br />
              <b>What Color is Visible in Diamond Fluorescence?</b>
              <br />
              Diamond grading reports also disclose the color produced by a
              diamond's fluorescence -- it's usually blue, yellow or white.
              <br />
              <br />
              <b>How Does Diamond Fluorescence Affect the Diamond</b>
              <br />
              If a yellowish diamond fluoresces blue, the effect could be strong
              enough to mask the yellowish tint when viewed under a jewelry
              store's fluorescent bulbs. You might be surprised by the diamond's
              true (yellowish) color when you look at it at home under different
              lighting.
              <br />
              The reverse is true for diamonds that fluoresce yellow. They can
              appear more white under incandescent lights, but acquire a
              yellowish tint in ultraviolet light.
              <br />
              <br />
              <b>Is Diamond Fluorescence Bad?</b>
              <br />
              Some retailers will tell you that fluorescence is bad... is a
              negative, but many consumers actually prefer diamonds with
              fluorescence! The truth is that fluorescence rarely affects a
              diamond's sparkle and brilliance, and in warmer or lower colored
              diamonds, fluorescence makes them look whiter or more colorless.
              Diamonds with fluorescence should be graded case by case. You may
              not even notice fluorescence in your diamonds, unless you are at a
              nightclub with black lights... Have fun and enjoy the blue glow!
              <br />
              <br />
              About a third of diamonds exhibit fluorescence, like the
              fluorescent minerals you have seen in natural history museums or
              the novelty shop toys under the black (UV) light. The effect is
              like a white shirt in a discotheque. Fluorescence can be faint to
              very strong, and the most common fluorescent color is blue. As
              blue is the complimentary color to yellow, the most common tinted
              color in diamonds, blue fluorescence can make yellowish diamonds
              look white or colorless.
              <br />
              <br />
              <b>Fluorescence in Multi-Stone Rings</b>
              <br />
              Most fluorescence is subtle. You probably will not see it as a
              true color change, just a slight shift in tone. However, the
              difference could make a diamond ring with multiple stones seem out
              of balance if some of the stones fluoresce and others do not, or
              if they fluoresce different colors.
              <br />
              <br />
              <b>Pricing for Diamonds that Fluoresce</b>
              <br />
              A strong yellow fluorescence can bring diamond prices down,
              sometimes quite a bit, since yellowish tinted diamonds are
              generally less desirable than whiter stones.
              <br />
              A blue fluorescence can help increase the prices of diamonds with
              yellowish tones.
              <br />
              <br />
              It's important for you to be happy with the diamonds you buy. Ask
              your jeweler to show you examples of fluorescence and try to look
              at diamonds in many types of light before you make a decision,
              especially if you are considering diamonds with no grading
              documentation.
            </p>
          </div>
        </div>
          <div className="shape-imgs-center">
            <img
              src={require("../../assets/education/Florocense.jpg")}
              alt="Fluorescence in Multi-Stone Rings"
            />
          </div>
      </div>
    ),
  },
  {
    title: "Certification",
    content: (
      <div >
        <div className="containerxyz">
          <div className="text-contentxyz">
            <p className="headingxyz">Certification</p>
            <p className="paragraphxyz">
              <b>What are Certified Diamonds?</b>
              <br />
              Loose diamonds (not pre-set in a ring or other setting) that have
              been certified by Gemological Laboratory.
              <br />
              <br />
              A certificate is a "blueprint" of a diamond, it tells you the
              diamond's exact measurements and weight, as well as the details of
              its cut and quality. It precisely points out all the individual
              characteristics of the stone. Certificates also serve as proof of
              the diamond's identity and value.
              <br />
              <br />
              A certificate is not the same thing as an appraisal. A certificate
              describes the quality of a diamond, but it does not place a
              monetary value on the gem. An appraisal places a monetary value on
              your diamond, but does not certify the quality of the diamond.
              <br />
              <br />
              <b>Who Issues Certificates?</b>
              <br />
              There are many diamond labs that issue certificates, but the
              Gemological Institute of America (GIA) and the American Gem
              Society (AGS) are the two most widely regarded and recognized
              diamond grading labs in the world.
              <br />
              <br />
              And while there are many other diamond grading labs in operation,
              such as IGI, HRD, EGL, VGR, CGL, DGL, PGS, different labs have
              different grading standards, and some labs will be more lenient
              with their standards than others. Therefore, we recommend buying
              from a diamond jewelry store that offers GIA or AGS certified
              diamonds, as these labs have consistently demonstrated their
              commitment to high standards. If you do elect to buy non GIA- or
              AGS- certified diamonds, always ask for credentials of the
              certifying lab.
              <br />
              <br />
              <b>Why Do We Need a Certificate?</b>
              <br />
              Shopping for certified diamonds allows you to make an informed
              choice about your diamond selections and to comparison shop among
              various diamond merchants. You can compare one diamond with a
              particular weight and quality with other diamonds of similar
              weight and quality to determine which diamond is the better value
              -- or which merchant has the best prices.
            </p>
          </div>
          <div className="shape-imgsxyz">
            <img
              src={require("../../assets/education/Cerficate.jpg")}
              alt="Certified Diamond Example"
            />
          </div>
        </div>
      </div>
    ),
  },
  {
    title: "What is Luster in Diamond",
    content: (
      <div >
        <div className="containerxyz">
          <div className="text-contentxyz">
            <p className="paragraphxyz">
              The physical characteristic of diamond is adamantine – brilliant
              light-reflecting and transmitting properties – to waxy.
              <br />
              <br />
              The luster of diamond is described as "adamantine to waxy," which
              is a scientific description of its physical characteristic.
              <br />
              <br />
              Luster refers to the clarity and refractivity of a particular
              stone. Not all diamonds are created equal. Flawless diamonds are
              extremely rare and prohibitively expensive for most of us. In
              jewelry, we usually have diamonds graded from VVSI (very very
              slightly included) to SI2 (slightly included 2): the latter being
              generally the lowest grade for gem-quality diamonds. Inclusions
              can be any imperfection.
              <br />
              <br />
              Luster refers to how well an object shines or reflects light. It
              is a property that can be used to describe rocks, minerals, or any
              reflective surface. In this case, it refers to how well a diamond
              reflects light.
              <br />
              <br />
              Luster is essentially a mineral's refractiveness – its ability to
              bounce back available light from within. This can be affected by
              factors such as the color, cut, or clarity of a gem-quality
              diamond. (Only 20% of all diamonds are gem-quality.)
              <br />
              <br />
              The physical characteristic of diamond, the mineral, is adamantine
              – meaning it has brilliant light-reflecting and transmitting
              properties – as opposed to a waxy appearance.
            </p>
          </div>
        </div>
      </div>
    ),
  },
  {
    title: "Treatment",
    content: (
      <div >
        <div className="containerxyz">
          <div className="text-contentxyz">
            <p className="headingxyz">Diamond Treatment</p>
            <p className="paragraphxyz">
              Diamond treatments are performed on natural diamonds (usually
              those already cut and polished into gems), designed to improve the
              gemological characteristics — and therefore the value — of the
              stone in one or more ways. These treatments include clarity
              enhancements, color treatments, and processes to give fancy colors
              to a white or off-color diamond.
              <br />
              <br />
              Following are various diamond treatments:
              <br />
              <br />
              <b>Clarity Enhanced:</b> Diamonds are occasionally laser drilled
              to eliminate dark inclusions. Some diamonds may also undergo
              fracture filling, where a foreign substance is applied to fill
              cracks. This substance has good stability except during repairs.
              Fracture filling is the process of filling a fracture of a
              gemstone with a substance of the same optical density as the
              gemstone itself. These diamonds are called clarity enhanced and
              must be disclosed.
              <br />
              <br />
              <b>Irradiation:</b> Irradiation of diamonds has been around for a
              long time and uses a nuclear reactor or linear accelerator to
              create fancy colored stones. These diamonds are generally
              over-colored and then annealed (heated) to soften the shade back
              to a desirable and permanent color. Such treatments need to be
              disclosed by merchants/vendors as well as labs, as it is illegal
              not to.
              <br />
              <br />
              <b>HPHT Process:</b> The HPHT process, using high pressure and
              high temperature, changes inexpensive brown diamonds into near
              colorless white diamonds, which are worth more than twice as much.
            </p>
          </div>
        </div>
      </div>
    ),
  },
  {
    title: "Cutting Process",
    content: (
      <div >
        <div className="containerxyz">
          <div className="text-contentxyz">
            <p className="headingxyz">Diamond Cutting Process</p>
            <p className="paragraphxyz">
              Diamond cutting is the practice of changing a diamond from a rough
              stone into a polished diamond (faceted gem). Cutting a diamond
              requires specialized knowledge, tools, equipment, and techniques
              due to its extreme difficulty.
              <br />
              <br />
              The diamond cutting process includes these steps: planning,
              cleaving or sawing, bruting, polishing, and final inspection.
              <br />
              <br />
              <b>Planning:</b> Planning is a crucial step in diamond
              manufacturing because it determines the size and relative value of
              the cut stones the rough will produce. A planner decides where to
              mark the diamond rough for fashioning into the most profitable
              polished gem(s). The planner must consider the size, clarity, and
              crystal direction when marking the diamond. Incorrectly marking
              the diamond by even a fraction of a millimeter can result in
              significant loss in value, sometimes thousands of dollars.
              Incorrect cleaving could even cause the diamond to shatter and
              become worthless.
              <br />
              <br />
              <b>Maximizing Value:</b> The process of maximizing the value of
              finished diamonds is both an art and a science. The choice of cut
              is influenced by many factors, including the exponential increase
              in value as diamond weight increases and the popularity of certain
              shapes. Physical factors like the original shape of the rough
              stone and the location of inclusions are also considered.
              <br />
              <br />
              <b>Weight Retention:</b> The weight retention analysis studies the
              diamond rough to find the best combination of finished stones and
              their per-carat value. Cutting and polishing always result in a
              dramatic loss of weight (about 50%), and sometimes compromises are
              made to preserve the weight at the expense of cut quality.
              <br />
              <br />
              <b>Color Retention:</b> In colored diamonds, cutting can influence
              the color grade, thus raising its value. Certain cut shapes
              intensify the diamond's color, such as the radiant cut.
              <br />
              <br />
              <b>Cleaving or Sawing:</b> Cleaving is the process of separating a
              diamond rough into pieces. The diamond is manually cleaved or
              sawed using a diamond-coated rotary saw or laser.
              <br />
              <br />
              <b>Bruting:</b> Bruting is where two diamonds are placed onto
              spinning axles, turning in opposite directions. The diamonds grind
              against each other, shaping each into a round form. This process
              creates the basic face-up outline of a round diamond, preparing it
              for faceting.
              <br />
              <br />
              <b>Polishing:</b> Polishing is the final stage, where the diamond
              receives its finished proportions. This stage includes blocking,
              where the first 17 or 18 facets are created, and then
              brillianteering, where the final facets are polished. This stage
              determines how much brilliance and fire the diamond displays.
              <br />
              <br />
              <b>Final Inspection and Grading:</b> A diamond's value is
              determined by the "4 C's": Clarity, Color, Cut (proportion), and
              Carat Weight. The closer a diamond grades to the left of any of
              these scales, the rarer and more valuable the stone. While clarity
              is often assumed to be the most important, color and cut
              (especially cut) have a greater impact on the diamond's visual
              appearance.
            </p>
          </div>
        </div>
      </div>
    ),
  },
];
